var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.527 5.46633C17.8217 5.75736 17.8247 6.23223 17.5337 6.52697L11.6091 12.527C11.4682 12.6697 11.276 12.75 11.0754 12.75C10.8748 12.75 10.6826 12.6697 10.5417 12.527L8.96633 10.9315C8.67529 10.6368 8.67829 10.1619 8.97303 9.87087C9.26777 9.57984 9.74264 9.58284 10.0337 9.87758L11.0754 10.9326L16.4663 5.47303C16.7574 5.17829 17.2322 5.17529 17.527 5.46633ZM11.5303 5.46967C11.8232 5.76256 11.8232 6.23744 11.5303 6.53033L5.53033 12.5303C5.23744 12.8232 4.76256 12.8232 4.46967 12.5303L1.46967 9.53033C1.17678 9.23744 1.17678 8.76256 1.46967 8.46967C1.76256 8.17678 2.23744 8.17678 2.53033 8.46967L5 10.9393L10.4697 5.46967C10.7626 5.17678 11.2374 5.17678 11.5303 5.46967Z",
    fill: "#999FAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRead);
export default __webpack_public_path__ + "static/media/read.d5bd856a31f21e6068696f255c0c7961.svg";
export { ForwardRef as ReactComponent };